import { InjectionToken, Injector, ViewContainerRef } from "@angular/core";
import esri = __esri;
import { loadModules } from "esri-loader";
import { Observable, from, empty, Subject } from "rxjs";
import { map } from 'rxjs/operators';
import { VIEW_WIDGETS } from "../models/widgets.model";
import { WidgetPosition } from "../../../../builder/components/state/controls/config/data/well-related/gis-map/widget-manager/models/GIS-widget.models";


export abstract class Renderer<T extends esri.View> {
    protected config: any;
    protected containerElement: HTMLDivElement;
    protected baseMap: string = "satellite";
    protected _view: T;

    get view() {
        return this._view;
    }

    constructor(protected injector: Injector) {
    }
    
    abstract render(): Observable<any>;
    abstract initialize(): Observable<T> | T;
    abstract export(): Observable<any>;

    dataUpdated: Subject<any> = new Subject<any>();

    protected createWidgets(): Observable<any> {
        if (this.config.widgets && this._view) {
            return from(loadModules([
                "esri/widgets/BasemapToggle",
                "esri/widgets/BasemapGallery",
                "esri/widgets/LayerList",
                "esri/widgets/Home",
                "esri/widgets/Compass"
            ])).pipe(map(([BasemapToggle, BasemapGallery, LayerList, Home, Compass]) => {
                let home = new Home({
                    view: this._view
                });
                this._view.ui.add(home, WidgetPosition.topLeft);
                this.config.widgets.forEach(x => {
                    let widget = null;
                    switch (x.type) {
                        case VIEW_WIDGETS.basemapToggle:
                            widget = new BasemapToggle({
                                view: this._view,
                            });

                            break;
                        case VIEW_WIDGETS.basemapGallery:
                            widget = new BasemapGallery({
                                view: this._view,
                            });

                            break;
                        case VIEW_WIDGETS.compass:
                            widget = new Compass({
                                view: this._view,
                            });

                            break;
                        case VIEW_WIDGETS.layerList:
                            widget = new LayerList({
                                view: this._view,
                                listItemCreatedFunction: function (event) {
                                    setTimeout(function () {
                                        const item = event.item;
                                        const itemUId = `${widget.id}_${item.uid}__title`;
                                        const node = document.getElementById(itemUId);
                                        if (node) {
                                            if (node.parentElement) {
                                                const parent = node.parentElement;
                                                if (parent.parentElement) {
                                                    const grandparent = parent.parentElement;
                                                    grandparent.style.padding = "0px";
                                                }
                                            }
                                        }
                                    }, 50);
                                }
                            });

                            break;
                        default:
                            console.debug('widget type not supported.');
                            break;
                    }
                    this._view.ui.add(widget, x.position);

                });
            }));
        }
        else
            return empty();
    }
}

export const CONFIG: InjectionToken<any> = new InjectionToken("Config");
export const MAP_ELEMENT: InjectionToken<HTMLDivElement> = new InjectionToken("Element");
export const OVERLAY_CONTAINER: InjectionToken<ViewContainerRef> = new InjectionToken("Overlay Container");
